import { jsx as _jsx } from "react/jsx-runtime";
import { ArrowLeft, MenuIcon } from 'lucide-react';
import { WalletIcon } from '@layerswap/ui-kit/components';
import IconButton from '../Buttons/iconButton';
export function WidgetBackButton({ onClick }) {
    return (_jsx("div", { className: "ml-0", children: _jsx(IconButton, { onClick: onClick, "aria-label": "Go back", icon: _jsx(ArrowLeft, { strokeWidth: 2 }) }) }));
}
export function WidgetMenuButton({ onClick }) {
    return (_jsx("div", { className: "sm:-mr-2 mr-0", children: _jsx(IconButton, { "aria-label": "Menu", className: "inline-flex active:animate-press-down", onClick: onClick, icon: _jsx(MenuIcon, { strokeWidth: 2 }) }) }));
}
export function ConnectButtonView({ children, className, disabled, onClick, }) {
    return (_jsx("button", { onClick: onClick, "data-attr": "connect-wallet", type: "button", "aria-label": "Connect wallet", disabled: disabled, className: `${className} disabled:opacity-50 disabled:cursor-not-allowed enabled:active:animate-press-down`, children: children }));
}
export function WalletHeaderIcon() {
    return (_jsx("div", { className: "p-1.5 max-sm:p-2 active:animate-press-down justify-self-start text-secondary-text hover:bg-secondary-500 max-sm:bg-secondary-500 hover:text-primary-text focus:outline-hidden inline-flex rounded-lg items-center", children: _jsx(WalletIcon, { className: "h-6 w-6 mx-0.5", strokeWidth: "2" }) }));
}
